module.exports = __webpack_public_path__ + "static/img/3.fb51081.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/3.png
// module id = aSWv
// module chunks = 0